<template>
    <div class="t-lk-promotions">
        <div class="t-lk-container">
            <banner-native-cmp v-if="banner" v-animation:bottom.delay :banner="banner"></banner-native-cmp>
            <lk-title-link-cmp
                v-animation:bottom.delay
                :title="$root.staticText.lk.promotionsTitle"
                :link="'/promotions'"
                :name="$root.staticText.lk.promotionsAll"
            ></lk-title-link-cmp>
            <div v-if="promotions && promotions.length > 0" class="t-lk-promotions__container">
                <div v-animation:bottom.delay v-for="item in promotions" class="t-lk-promotions__item">
                    <div class="t-lk-promotions__row">
                        <div class="t-lk-promotions__img">
                            <img v-if="item.img" :src="item.img" :alt="item.name">
                        </div>
                        <div class="t-lk-promotions__date">{{ item.date }}</div>
                    </div>
                    <div class="t-lk-promotions__name">{{ item.name }}</div>
                    <div class="t-lk-promotions__desc" v-html="item.description"></div>
                    <div v-if="item.target || item.status" class="t-lk-promotions__row _target">
                        <div class="t-lk-promotions__target">
                            <div v-if="item.target" class="t-lk-promotions__subtitle">
                                {{ $root.staticText.lk.target }}
                            </div>
                            <div v-if="item.target" class="t-lk-promotions__text" v-html="item.target"></div>
                        </div>
                        <div class="t-lk-promotions__status">
                            <div v-if="item.status" class="t-lk-promotions__subtitle">
                                {{ $root.staticText.lk.status }}
                            </div>
                            <div v-if="item.status" class="t-lk-promotions__text" v-html="item.status"></div>
                            <div v-if="item.status && item.progress" class="t-lk-promotions__progress">
                                <span :style="'width: ' + item.progress + '%;'"></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.reward" class="t-lk-promotions__reward" :class="{_gray: item.rewardClass}">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.9999 25.6668C20.4432 25.6668 25.6666 20.4435 25.6666 14.0002C25.6666 7.55684 20.4432 2.3335 13.9999 2.3335C7.5566 2.3335 2.33325 7.55684 2.33325 14.0002C2.33325 20.4435 7.5566 25.6668 13.9999 25.6668Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14 21C17.866 21 21 17.866 21 14C21 10.134 17.866 7 14 7C10.134 7 7 10.134 7 14C7 17.866 10.134 21 14 21Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.0001 16.3332C15.2887 16.3332 16.3334 15.2885 16.3334 13.9998C16.3334 12.7112 15.2887 11.6665 14.0001 11.6665C12.7114 11.6665 11.6667 12.7112 11.6667 13.9998C11.6667 15.2885 12.7114 16.3332 14.0001 16.3332Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        {{ $root.staticText.lk.reward }} {{ item.reward }}
                    </div>
                </div>
            </div>
            <div
                v-else
                v-animation:bottom.delay
                class="t-lk-main__not t-lk-container-mobile t-lk-services-item__text"
            >
                {{$root.staticText.lk.mainPromotionsNot}}
            </div>

            <template v-if="promotionsCompleted.length > 0 || $route.query.q">
                <h2 v-animation:bottom.delay class="t-lk-title t-lk-container-mobile">
                    {{ $root.staticText.lk.promotionsCompletedTitle }}
                </h2>
                <div v-animation:bottom.delay class="t-lk-promotions-completed">
                    <div v-animation:bottom.delay class="t-lk-promotions-completed__row">
                        <lk-search-cmp
                            :obj-undefined="{currentPageCompleted: undefined}"
                            :animation="'completed'"
                        >
                        </lk-search-cmp>
                        <filter-cmp
                            v-if="filterCompleted"
                            class="t-lk-promotions-completed__filter"
                            :filter="filterCompleted"
                            :animation="'completed'"
                            :obj-undefined="{currentPageCompleted: undefined}"
                            :name-btn="$root.staticText.lk.promotionsFilterBtn"
                            :is-date="true"
                        >
                        </filter-cmp>
                    </div>
                    <div class="t-lk-promotions-completed-table">
                        <div v-animation:bottom.delay class="t-lk-promotions-completed-table__row _first">
                            <div
                                class="t-lk-promotions-completed-table__th t-lk-promotions-completed-table__td"
                                v-for="item in promotionsCompletedTitle"
                            >
                                {{ item }}
                            </div>
                        </div>
                        <div class="js-completed">
                            <div
                                v-animation:bottom.delay
                                v-for="item in promotionsCompleted"
                                class="t-lk-promotions-completed-table__row"
                            >
                                <div class="t-lk-promotions-completed-table__td">
                                    <div class="t-lk-promotions-completed-table__name">{{ item.name }}</div>
                                    <div class="t-lk-promotions-completed-table__desc" v-html="item.description"></div>
                                </div>
                                <div class="t-lk-promotions-completed-table__td _top">
                                    <div class="t-lk-promotions-completed-table__date">{{ item.date }}</div>
                                </div>
<!--                                <div class="t-lk-promotions-completed-table__td _top">-->
<!--                                    <div class="t-lk-promotions-completed-table__status" :class="{_gray: item.rewardClass}">-->
<!--                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                            <path d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                            <path d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z" stroke="#00b0bd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                        </svg>-->
<!--                                        {{ item.reward }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <div class="t-lk-promotions-completed-table__td _top">-->
<!--                                    <div v-if="item.rewardType === 0" class="t-lk-promotions-completed-table__reward">-->
<!--                                        {{ $root.staticText.lk.promotionsCompletedText }} {{ item.rewardDate }}-->
<!--                                    </div>-->
<!--                                    <a-->
<!--                                        v-else-if="item.rewardType === 1"-->
<!--                                        :href="item.rewardFile"-->
<!--                                        target="_blank"-->
<!--                                        class="t-btn _lk _border-green"-->
<!--                                    >-->
<!--                                        {{ $root.staticText.lk.promotionsCompletedBtn }}-->
<!--                                    </a>-->
<!--                                    <div v-else-if="item.rewardType === 2">-->
<!--                                        <div class="t-lk-promotions-completed-table__subtitle">-->
<!--                                            {{ $root.staticText.lk.promotionsCompletedText2 }}-->
<!--                                        </div>-->
<!--                                        <div class="t-lk-promotions-completed-table__subtext">-->
<!--                                            {{ $root.staticText.lk.promotionsCompletedText3 }}-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                    <div v-if="item.rewardType === 3" class="t-lk-promotions-completed-table__reward">-->
<!--                                        {{ $root.staticText.lk.promotionsCompletedText4 }}-->
<!--                                    </div>-->
<!--                                    <div v-if="item.rewardType === 4" class="t-lk-promotions-completed-table__reward">-->
<!--                                        <div class="t-lk-promotions-completed-table__subtitle">-->
<!--                                            {{ $root.staticText.lk.promotionsCompletedText5 }}-->
<!--                                        </div>-->
<!--                                        <a class="t-btn-green" :href="item.rewardFile" target="_blank">-->
<!--                                            {{ $root.staticText.lk.promotionsCompletedText6 }}-->
<!--                                        </a>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                        </div>
                    </div>
                </div>
                <pagination-cmp
                    v-animation:bottom.delay
                    v-if="paginationCompleted"
                    :pagination="paginationCompleted"
                    :name-current-page="'currentPageCompleted'"
                    :animation="'completed'"
                    class="t-lk-promotions-completed__pag _lk"
                >
                </pagination-cmp>
            </template>

            <template v-if="promotionsSelection.length > 0">
                <h2 v-animation:bottom.delay class="t-lk-title t-lk-container-mobile">
                    {{ $root.staticText.lk.promotionsSelectionTitle }}
                </h2>
                <filter-cmp
                    v-animation:bottom.delay
                    v-if="filterSelection"
                    class="t-lk-promotions-selection__filter _white"
                    :filter="filterSelection"
                    :animation="'selection'"
                    :obj-undefined="{currentPageSelection: undefined}"
                    :name-btn="$root.staticText.lk.promotionsFilterBtn"
                    :white="true"
                >
                </filter-cmp>
                <div class="t-lk-promotions-selection js-selection">
                    <div
                        v-animation:bottom.delay
                        v-for="item in promotionsSelection"
                        class="t-lk-promotions-selection__item"
                    >
                        <div class="t-lk-promotions__row">
                            <div class="t-lk-promotions-selection__name">{{ item.name }}</div>
                            <div class="t-lk-promotions__date">{{ item.date }}</div>
                        </div>
                        <div class="t-lk-promotions-selection__desc" v-html="item.description"></div>
                        <div class="t-lk-promotions__row">
                            <div class="t-lk-promotions__img">
                                <img v-if="item.img" :src="item.img" :alt="item.name">
                            </div>
                            <router-link :to="item.link" class="t-lk-promotions-selection__link">
                                <template v-if="isMobile">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M14 2V8H20" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M12 18V12" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M9 15H15" stroke="#00b0bd" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </template>
                                <template v-else>
                                    {{ $root.staticText.lk.eventsSelectionBtn }}
                                </template>
                            </router-link>
                        </div>
                    </div>
                </div>
                <pagination-cmp
                    v-animation:bottom.delay
                    v-if="paginationSelection"
                    :pagination="paginationSelection"
                    :name-current-page="'currentPageSelection'"
                    :animation="'selection'"
                    class="t-lk-promotions-completed__pag _lk"
                >
                </pagination-cmp>
            </template>

        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import bannerNative from '@components/lk/banner-native/banner-native.vue';
    import titleLink from '@components/lk/lk-title-link/lk-title-link.vue';
    import lkSearch from '@components/lk/lk-search/lk-search.vue';
    import filter from '@components/lk/lk-filter/lk-filter.vue';
    import pagination from '@components/ui-components/pagination/pagination.vue';

    import onScrollAnimate from '@assets/js/scrollAnimate.js';
    import { mapState } from "vuex";

    export default {
        name: "lk-promotions",
        data() {
            return {
                banner: null,
                promotions: [],

                filterCompleted: null,
                promotionsCompletedTitle: [
                    this.$root.staticText.lk.promotionsCompletedTable,
                    this.$root.staticText.lk.promotionsCompletedTable2,
                    // this.$root.staticText.lk.promotionsCompletedTable3,
                    // this.$root.staticText.lk.promotionsCompletedTable4,
                ],
                promotionsCompleted: [],
                paginationCompleted: null,

                filterSelection: null,
                promotionsSelection: [],
                paginationSelection: null,
            }
        },
        components: {
            'banner-native-cmp': bannerNative,
            'lk-title-link-cmp': titleLink,
            'lk-search-cmp': lkSearch,
            'filter-cmp': filter,
            'pagination-cmp': pagination,
        },
        computed: {
            ...mapState('mobile', ['isMobile', 'isTablet']),
        },
        methods: {
            setData(data) {
                this.banner = data.banner;
                this.promotions = data.promotions;

                this.filterCompleted = data.filterCompleted;
                this.promotionsCompleted = data.promotionsCompleted;
                this.paginationCompleted = data.paginationCompleted;

                this.filterSelection = data.filterSelection;
                this.promotionsSelection = data.promotionsSelection;
                this.paginationSelection = data.paginationSelection;
            },
        },
        beforeRouteUpdate(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'lk/promotionsPage.json' : 'lk/promotions';

            if (to.query.animation === 'completed') {
                this.$root.setDataAnimateFalse('.js-completed ');
            } else if (to.query.animation === 'selection') {
                this.$root.setDataAnimateFalse('.js-selection ');
            }

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    this.setData(data.data);
                    next();
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 500);
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ? 'lk/promotionsPage.json' : 'lk/promotions';
            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                    
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/promotions/index.vue